/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Zoom_OutInputs */

const en_read_along_zoom_out = /** @type {(inputs: Read_Along_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out`)
};

const es_read_along_zoom_out = /** @type {(inputs: Read_Along_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alejar`)
};

/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Read_Along_Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_zoom_out = /** @type {((inputs?: Read_Along_Zoom_OutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Zoom_OutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_zoom_out(inputs)
	return en_read_along_zoom_out(inputs)
});